//RetroPGFSec3

// src/components/RetroPGFSec3.js
import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5%; 
  background-color: #000000; /* 调整背景颜色根据需要 */
  width:60%;
  margin: 0 auto;

  @media (max-width: 500px) {
    flex-direction: column; /* 在小于500px时，垂直排列 */
    padding: 5% 0% 0% 0%;
    width:90vw;
  }
`;

const LeftColumn = styled.div`
  flex: 4;
  
  @media (max-width: 500px) {

    width:100vw;
    text-align: center;
    
  }
  
`;

const Image = styled.img`
  width: auto;
  height: 100%;

  @media (max-width: 500px) {

    width: 90vw;
    height:auto;
    
    
    
  }
`;



const RightColumn = styled.div`
  flex: 6; 
  width:60%;
  overflow: hidden;
  padding:0% 0% 0% 5%;

  @media (max-width: 500px) {
    
    width:100%;
    padding:0% 0% 10% 0% ;

  }
  
`;

const GroupContainer = styled.div`
  margin-bottom: 2.5%; 
  margin-left: 2.5%; 

  padding:1%;

  @media (max-width: 500px) {
    width:100%;
    margin:0 auto;
   
    padding:0%;

  }
`;

const GroupTitle = styled.h3`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 41px;
  margin-bottom: 1%;
  margin-top: 1%; 
  color: #FFFFFF;
  padding:0% 0% 0% 0%;


  p{

    font-size: 18px;
    line-height: 32px;
    color: #AFAFAF;
    padding:0% 0% 3% 0%;
  }

  @media (max-width: 500px) {
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    padding:5% 0% 0% 2% ;

    p {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
  }

`;

const Button = styled.a`
  text-decoration: none;
  background-color:transparent;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;

  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;

  
  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    margin-top:0px;
    padding: 6px 20px;
    margin: 0 auto;


  }

  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }
`;

const RetroPGFSec3 = () => {
  return (
    <SectionContainer>
      <LeftColumn>
        <Image src="/images/RetroPGFSec3_1.png" alt="Image Title" />
      </LeftColumn>
      <RightColumn>
        <GroupContainer>
          <GroupTitle>RetroPGF 研究概括<p>本專案透過研究目前全球數位公共財發展狀況及分析目前台灣建造數位公共財現況，進而擬訂出一套更適合台灣環境的回溯性公共資助採購建議。也更近一步在開源社群中導入回溯性公共資助方法，希望藉此開啟社群永續營運的飛輪，讓開源社群可以獲得捐贈以外的資源挹注。</p></GroupTitle>
          <Button href="https://drive.google.com/file/d/1Hw12Qt8VqyudtQTWToS-OFom6Gf2152v/view?usp=sharing" target="_blank" style={{ textDecoration: 'none' }}>閱讀更多</Button>
         
        </GroupContainer>
        
      </RightColumn>

    </SectionContainer>
    

  );
};

export default RetroPGFSec3;
